module.exports = __webpack_public_path__ + "img/check-green-circle.d9a41022.svg";